import React from 'react';
import CheckTable from './components/CheckTable';
import { Box } from '@chakra-ui/react';

const orders = () => {
  return (
    <Box mt={-5}>
      <CheckTable />
    </Box>
  );
};

export default orders;
